import { useEffect, useMemo, useState } from "react";
import EntityPage from "@/components/EntityPage";
import { api, TIPI_BICI } from "@/lib/api";

export const biciFields = (clienti) => [
  { name: "cliente_id", label: "Cliente", type: "select", required: true, full: true, options: clienti.map((c) => ({ value: c.id, label: `${c.nome} ${c.cognome}`.trim() })) },
  { name: "marca", label: "Marca", required: true },
  { name: "modello", label: "Modello" },
  { name: "tipo", label: "Tipo", type: "select", options: TIPI_BICI },
  { name: "telaio", label: "N° telaio" },
  { name: "colore", label: "Colore" },
  { name: "taglia", label: "Taglia" },
  { name: "anno", label: "Anno" },
  { name: "note", label: "Note tecniche (gruppo, freni, ruote...)", type: "textarea" },
];

export default function Bici() {
  const [clienti, setClienti] = useState([]);
  useEffect(() => { api.get("/clienti").then((r) => setClienti(r.data)); }, []);
  const map = useMemo(() => Object.fromEntries(clienti.map((c) => [c.id, `${c.nome} ${c.cognome}`.trim()])), [clienti]);

  return (
    <EntityPage
      overline="Anagrafica" title="Bici dei clienti" endpoint="bici" prefix="bici" singular="bici" newLabel="Nuova bici"
      fields={biciFields(clienti)}
      deleteDescription="Non è possibile eliminare bici con schede di lavoro associate."
      columns={[
        { key: "marca", label: "Bici", render: (b) => <span className="font-semibold text-slate-900">{b.marca} {b.modello}</span> },
        { key: "tipo", label: "Tipo" },
        { key: "telaio", label: "N° telaio", render: (b) => <span className="font-mono text-xs">{b.telaio || "—"}</span> },
        { key: "colore", label: "Colore" },
        { key: "cliente_id", label: "Proprietario", render: (b) => map[b.cliente_id] || "—" },
      ]}
    />
  );
}
